import _ from 'lodash';
import React from 'react';
import {
  useParams,
  useLocation,
  useHistory,
} from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import axios from 'axios';
import Header from '../layout/Header.jsx';
import { useAsyncResource } from '../../../commons/hooks/useAsyncResource';
import { FieldArray, Form, Formik } from 'formik';
import { useAlert } from '../../../commons/components/alert/index.jsx';
import ListResource from '../../../admin/components/lists/ListResource.jsx';
import FieldArrayCards from '../../../admin/components/forms/FieldArrayCards.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import qs from 'qs';
import { array, object } from 'yup';
import FormErrorAlert from '../../../admin/components/forms/FormErrorAlert.jsx';
import useSearchParams from '~/commons/hooks/useSearchParams';
import { env } from '~/commons/config';

const path = (string = '', i) => `items.${i}.${string}`;
const path2 = (string = '', i) => `customers.${i}.${string}`;

const PageShareStockNew = () => {
  const { _id } = useParams();
  const loc = useLocation();
  const showAlert = useAlert();

  const { items: selected } = qs.parse(loc.search, { ignoreQueryPrefix: true }) || {};

  const breadcrumb = [
    { to: '/portal/shareStocks', children: 'Share History' },
  ];

  const { resource: { data: advFilterData = {} } = {} } = useAsyncResource(async () => {
    return axios.get('/api/core/stocks/advFilterData');
  }, []);

  const { resource: { data: doc = {} } = {} } = useAsyncResource(async () => {
    if (!_.isEmpty(selected)) {
      const { data: { rows = [] } = {} } = await axios.post('/api/core/stocks/list', {
        filter: {
          id: selected,
          status: 'Active',
        },
        skip: 0,
        limit: selected.length,
      });
      return { data: { _id, items: rows } };
    }
    return { data: { _id } };
  }, [_id]);

  const [filter, setFilter] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  return (
    <div className="py-4">
      <Header breadcrumb={breadcrumb}>Share Stocks</Header>
      <Formik
        key={doc._id}
        initialValues={{ ...doc }}
        validationSchema={object({
          customers: array().of(object()).required(),
          items: array().of(object()).required(),
        })}
        onSubmit={async (values) => {
          try {
            const res = await axios.post('/api/core/shareStocks', {
              customers: _.map(values.customers, (v) => v._id),
              items: _.map(values.items, (v) => v._id),
            });
            if (res.status === 200) {
              showAlert('success', 'Share successfully', 2000);
              const { _id } = res.data;
              window.location.href = `/portal/shareStocks/${_id}`;
            } else {
              showAlert('danger', 'Unknown error', 2000);
            }
          } catch (e) {
            if (e.response?.status === 400) {
              showAlert('danger', e.response.data, 2000);
            } else {
              showAlert('danger', e, 2000);
            }
          }
        }}
      >
        {({ values, setValues, ...props }) => (
          <Form>
            <FormErrorAlert {...props} />
            <button className='btn btn-primary mb-3'>{_id === 'new' ? 'Share Stocks' : 'Share Again'}</button>
            <Tabs defaultActiveKey="product" unmountOnExit>
              <Tab eventKey="product" title="Product List">
                <FieldArray name="items">
                  {(helper) => (
                    <div className="row">
                      <div className="col">
                        <ListResource
                          key='product'
                          useSearchKey={false}
                          api='/api/core/stocks'
                          sort={{ itemCode: 1 }}
                          filter={{
                            ..._.pickBy(filter, (v) => v),
                            status: 'Active',
                          }}
                          actions={{
                            create: false,
                            remove: false,
                          }}
                          searchable
                          onRowClick={(row) => {
                            const arr = _.get(values, 'items') || [];
                            const included = arr.map((r) => `${r.itemCode} - ${r.serialNo}`);
                            const item = `${row.itemCode} - ${row.serialNo}`;

                            if (!included.includes(item)) {
                              return helper.push(row);
                            }
                            return null;
                          }}
                          cols={[
                            {
                              key: 'itemCode',
                              sortable: true,
                              children: 'Item Code',
                            },
                            {
                              key: 'serialNo',
                              sortable: true,
                              children: 'Serial Number',
                            },
                            {
                              key: 'prices.currency',
                              sortable: true,
                              children: 'Currency',
                            },
                            {
                              key: 'prices.retailPrice',
                              sortable: true,
                              children: 'Price',
                              getter: (v) => (Number(v) || 0).toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }),
                            },
                          ]}
                          listHeader={(
                            <div className="form-row mb-3">
                              <div className="col">
                                <select
                                  className="custom-select"
                                  value={filter.brand}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setFilter(v => ({ ...v, brand: value }));
                                  }}
                                >
                                  <option value="">All Brand</option>
                                  {_.map(_.orderBy(advFilterData?.brand, '_id'), ({ _id: v }) => (
                                    <option value={v} key={v}>{v}</option>
                                  ))}
                                </select>
                              </div>
                              <div className="col">
                                <select
                                  className="custom-select"
                                  value={filter.construction}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setFilter(v => ({ ...v, construction: value }));
                                  }}
                                >
                                  <option value="">All Construction</option>
                                  {_.map(_.orderBy(advFilterData?.construction, '_id'), ({ _id: v }) => (
                                    <option value={v} key={v}>{v}</option>
                                  ))}
                                </select>
                              </div>
                              <div className="col">
                                <select
                                  className="custom-select"
                                  value={filter.collection}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setFilter(v => ({ ...v, collection: value }));
                                  }}
                                >
                                  <option value="">All Collection</option>
                                  {_.map(_.orderBy(advFilterData?.collection, ({ _id: v, name }) => name || v), ({ _id: v, name }) => (
                                    <option value={v} key={v}>{name || v}</option>
                                  ))}
                                </select>
                              </div>
                              <div className="col">
                                <select
                                  className="custom-select"
                                  value={filter.location}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setFilter(v => ({ ...v, location: value }));
                                  }}
                                >
                                  <option value="">All Location</option>
                                  {_.map(_.orderBy(advFilterData?.location, '_id'), ({ _id: v }) => (
                                    <option value={v} key={v}>{v}</option>
                                  ))}
                                </select>
                              </div>
                              <div className="col">
                                <button
                                  className='btn btn-primary'
                                  disabled={loading}
                                  type="button"
                                  onClick={async () => {
                                    try {
                                      setLoading(true);
                                      const res = await axios.get('/api/core/stocks', {
                                        params: {
                                          filter: {
                                            ..._.pickBy(filter, (v) => v),
                                            status: 'Active',
                                          },
                                          listAll: true,
                                        },
                                        paramsSerializer: (params) => (
                                          qs.stringify(params)
                                        ),
                                      });

                                      if (res.status === 200) {

                                        const arr = _.get(values, 'items') || [];
                                        const included = arr.map((r) => `${r.itemCode} - ${r.serialNo}`);

                                        const list = [];
                                        for (const item of res.data.rows || []) {
                                          const itemStr = `${item.itemCode} - ${item.serialNo}`;
                                          if (!included.includes(itemStr)) {
                                            list.push(item);
                                          }
                                        }

                                        setValues(v => ({
                                          ...v,
                                          items: [...v.items || [], ...list],
                                        }));

                                      } else {
                                        showAlert('danger', 'Unknown error', 2000);
                                      }

                                    } catch (e) {
                                      if (e.response?.status === 400) {
                                        showAlert('danger', e.response.data, 2000);
                                      } else {
                                        showAlert('danger', e, 2000);
                                      }
                                    } finally {
                                      setLoading(false);
                                    }
                                  }}>
                                  {loading && (
                                    <FA
                                      icon={faSpinner}
                                      className="mr-1"
                                      spin
                                    />
                                  )}
                                  Add Stocks
                                </button>
                              </div>
                            </div>
                          )}
                        >
                        </ListResource>
                      </div>
                      <div className="col">
                        <div className='my-2'>
                          Total Stock Items: <strong>{_.size(_.get(values, 'items'))} Stocks</strong>
                        </div>
                        <FieldArrayCards name="items" paginate>
                          {(s, i) => (
                            <>
                              <div className="row">
                                <div className="col">
                                  <FormGroup
                                    key={path('itemCode', i)}
                                    name={path('itemCode', i)}
                                    label="Item Code"
                                    disabled
                                  />
                                </div>
                                <div className="col">
                                  <FormGroup
                                    key={path('serialNo', i)}
                                    name={path('serialNo', i)}
                                    label="Serial No"
                                    disabled
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col">
                                  <FormGroup
                                    key={path('prices.retailPrice', i)}
                                    name={path('prices.retailPrice', i)}
                                    label="Price"
                                    disabled
                                  />
                                </div>
                                <div className="col">
                                  <FormGroup
                                    key={path('status', i)}
                                    name={path('status', i)}
                                    label="Status"
                                    disabled
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </FieldArrayCards>
                      </div>
                    </div>
                  )}
                </FieldArray>
              </Tab>
              <Tab eventKey="customers" title="Customer">
                <FieldArray name="customers">
                  {(helper) => (
                    <div className="row">
                      <div className="col">
                        <ListResource
                          key='customers'
                          useSearchKey={false}
                          api='/api/core/users/customers'
                          actions={{
                            create: false,
                            remove: false,
                          }}
                          filter={{
                            hasEmail: true,
                          }}
                          searchable
                          onRowClick={(row) => {
                            const arr = _.get(values, 'customers') || [];
                            const included = arr.map((r) => r._id);
                            if (!included.includes(row._id)) {
                              return helper.push(row);
                            }
                            return null;
                          }}
                          cols={[
                            {
                              key: 'name.full.en',
                              sortable: true,
                              children: 'English Name',
                            },
                            {
                              key: 'email',
                              sortable: true,
                              children: 'Email',
                            },
                            {
                              key: 'mobile.code',
                              sortable: true,
                              children: 'Country Code',
                            },
                            {
                              key: 'mobile.number',
                              sortable: true,
                              children: 'Phone',
                            },
                          ]}
                        >
                        </ListResource>
                      </div>
                      <div className="col">
                        <div className='my-2'>
                          Total Customers: <strong>{_.size(_.get(values, 'customers'))} Customers</strong>
                        </div>
                        <FieldArrayCards name="customers" paginate>
                          {(s, i) => (
                            <>
                              <div className="row">
                                <div className="col">
                                  <FormGroup
                                    key={path2('name.full.en', i)}
                                    name={path2('name.full.en', i)}
                                    label="Name"
                                    disabled
                                  />
                                </div>
                                <div className="col">
                                  <FormGroup
                                    key={path2('orgId', i)}
                                    name={path2('orgId', i)}
                                    label="Organization ID"
                                    disabled
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col">
                                  <FormGroup
                                    key={path2('email', i)}
                                    name={path2('email', i)}
                                    label="Email"
                                    disabled
                                  />
                                </div>
                                <div className="col">
                                  <div className="form-group">
                                    <label>Phone</label>
                                    <div className="input-group">
                                      <input
                                        className='form-control'
                                        value={_.compact([
                                          _.get(values, path2('mobile.code', i)),
                                          _.get(values, path2('mobile.number', i)),
                                        ]).join('-')}
                                        disabled
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </FieldArrayCards>
                      </div>
                    </div>
                  )}
                </FieldArray>
              </Tab>
            </Tabs>
          </Form>
        )}
      </Formik>
    </div>
  );
};

const PageShareStockOld = () => {
  const history = useHistory();
  const { _id } = useParams();

  const breadcrumb = [
    { to: '/portal/shareStocks', children: 'Share History' },
  ];

  const { resource: { data: advFilterData = {} } = {} } = useAsyncResource(async () => {
    return axios.get('/api/core/stocks/advFilterData');
  }, []);

  const { resource: { data: showrooms } = {} } = useAsyncResource(async () => {
    return axios.get('/api/core/users/self/showrooms');
  }, []);

  const [searchParams, setSearchParams] = useSearchParams({});
  const filter = {
    brand: searchParams.get('brand') || '',
    construction: searchParams.get('construction') || '',
    collection: searchParams.get('collection') || '',
    status: searchParams.get('status') || '',
    orgId: searchParams.get('orgId') || '',
    location: searchParams.get('location') || '',
  };

  const showrms = _.uniqBy(showrooms, 'orgId');

  const { resource: { data: doc = {} } = {} } = useAsyncResource(async () => {
    return axios.get(`/api/core/shareStocks/${_id}`);
  }, [_id]);

  return (
    <div className="py-4">
      <Header breadcrumb={breadcrumb}>{_id === 'new' ? 'Share Stocks' : 'View'}</Header>
      <button
        className='btn btn-primary mb-3'
        type='button'
        onClick={() => {
          window.location.href = `/portal/shareStocks/new?${_.map(doc.items, (i) => `items[]=${i._id}`).join('&')}`;
        }}
      >Share Again</button>
      <Tabs defaultActiveKey="product" unmountOnExit>
        <Tab eventKey="product" title="Product List">
          <div className="row">
            <div className="col">
              <ListResource
                method='post'
                api='/api/core/stocks/list'
                actions={{
                  create: false,
                  remove: false,
                }}
                filter={{
                  ..._.pickBy(filter, (v) => v),
                  id: _.map(doc?.items, (i) => i._id),
                }}
                searchable
                onRowClick={(row) => {
                  history.push(`/portal/stocks/${row._id}`);
                }}
                sort={{ itemCode: 1 }}
                cols={[
                  {
                    key: 'itemCode',
                    sortable: true,
                    children: 'Item Code',
                  },
                  {
                    key: 'serialNo',
                    sortable: true,
                    children: 'Serial Number',
                  },
                  {
                    key: 'design.design',
                    sortable: true,
                    children: 'Design',
                  },
                  {
                    key: 'prices.currency',
                    sortable: true,
                    children: 'Currency',
                  },
                  {
                    key: 'prices.retailPrice',
                    sortable: true,
                    children: 'Price',
                    getter: (v) => (Number(v) || 0).toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }),
                  },
                  { key: 'size', sortable: true },
                  { key: 'location', sortable: true },
                ]}
                listHeader={(
                  <div className="form-row mb-3">
                    <div className="col">
                      <select
                        className="custom-select"
                        value={filter.brand}
                        onChange={(e) => {
                          setSearchParams({ brand: e.target.value });
                        }}
                      >
                        <option value="">All Brand</option>
                        {_.map(advFilterData?.brand, ({ _id: v }) => (
                          <option value={v} key={v}>{v}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col">
                      <select
                        className="custom-select"
                        value={filter.construction}
                        onChange={(e) => {
                          setSearchParams({ construction: e.target.value });
                        }}
                      >
                        <option value="">All Construction</option>
                        {_.map(advFilterData?.construction, ({ _id: v }) => (
                          <option value={v} key={v}>{v}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col">
                      <select
                        className="custom-select"
                        value={filter.collection}
                        onChange={(e) => {
                          setSearchParams({ collection: e.target.value });
                        }}
                      >
                        <option value="">All Collection</option>
                        {_.map(advFilterData?.collection, ({ _id: v, name }) => (
                          <option value={v} key={v}>{name || v}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col">
                      <select
                        className="custom-select"
                        value={filter.status}
                        onChange={(e) => {
                          setSearchParams({ status: e.target.value });
                        }}
                      >
                        <option value="">All Status</option>
                        {(env?.status?.stocks || []).map((v) => (
                          <option value={v} key={v}>
                            {_.startCase(v)}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col">
                      <select
                        className="custom-select"
                        value={filter.orgId}
                        onChange={(e) => {
                          setSearchParams({ orgId: e.target.value });
                        }}
                      >
                        <option value="">All OrgIds</option>
                        {showrms.map((a) => (
                          <option key={a.orgId} value={a.orgId}>
                            {`${a.orgId} - ${a.countryCode}`}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col">
                      <select
                        className="custom-select"
                        value={filter.location}
                        onChange={(e) => {
                          setSearchParams({ location: e.target.value });
                        }}
                      >
                        <option value="">All Location</option>
                        {_.map(advFilterData?.location, ({ _id: v }) => (
                          <option value={v} key={v}>{v}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              >
              </ListResource>
            </div>
          </div>
        </Tab>
        <Tab eventKey="customers" title="Customer">
          <div className="row">
            <div className="col">
              <ListResource
                api='/api/core/users/customers'
                filter={{
                  id: _.map(doc?.customers, (i) => i._id),
                }}
                actions={{
                  create: false,
                  remove: false,
                }}
                searchable
                onRowClick={() => { }}
                cols={[
                  {
                    key: 'name.full.en',
                    sortable: true,
                    children: 'English Name',
                  },
                  {
                    key: 'email',
                    sortable: true,
                    children: 'Email',
                  },
                  {
                    key: 'mobile.code',
                    sortable: true,
                    children: 'Country Code',
                  },
                  {
                    key: 'mobile.number',
                    sortable: true,
                    children: 'Phone',
                  },
                ]}
              >
              </ListResource>
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

const PageShareStock = () => {
  const { _id } = useParams();
  if (_id === 'new') {
    return <PageShareStockNew />;
  }
  return <PageShareStockOld />;
};

export default PageShareStock;
